"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Linkedin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Team() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const teamMembers = [{
    id: 1,
    name: "Paolo D'Angelo",
    role: "Co Founder / Executive Chairman",
    bio: "\"I love serving with my skill of knowing what is going on with leaders and what they must know & do to have the mental capacity to create positive effective relationships, have good support & protection in market fluctuations and disruptions, and long successful tenures\nin good health.\"",
    photo: "https://sincere-skink.10web.cloud/wp-content/uploads/2026/02/Paolo-pic-copy-scaled.jpg?v=6t7k7tij3oo"
  }, {
    id: 3,
    name: "Raamon Newman",
    role: "Co Founder / CEO",
    bio: "\"It's been a joy to support Founders, CEOs & leaders to have even more clarity, coherence, creativity & capacity through proven approaches to be the most powerful catalyst they can be to capitalize on opportunities that achieve breakthrough protected progress\nin less time.”",
    photo: "https://sincere-skink.10web.cloud/wp-content/uploads/2026/02/Raamon-Newman-headshot-copy.jpg?v=unfjxpl7mxn"
  }];
  const socialLinks = [{
    personId: 1,
    linkedin: "https://linkedin.com/in/alicejohnson",
    twitter: "https://twitter.com/alicejohnson",
    github: ""
  }, {
    personId: 3,
    linkedin: "https://www.linkedin.com/in/raamonnewman/",
    twitter: "https://twitter.com/sarachen",
    github: "https://github.com/sarachen"
  }];
  return <section id="team" ref={sectionRef} className="bg-background py-16 ![margin:-20px_0px_0px_0px] hidden md:block">
      <div className="w-full">
        <div className="text-center mb-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="font-display font-bold text-foreground !text-5xl ![margin:-30px_0px_0px_0px]">TEAM</h2>
            <p className="text-muted-foreground max-w-2xl mx-auto mt-6 !w-[750px] !text-[22px]">For three decades Paolo D'Angelo &amp; Raamon Newman have been globally trusted proven CEO Breakthrough Protection&nbsp;Partners to over 100 CEOs &amp; execs developing their leadership consciousness to grow multi million &amp; billion valued&nbsp; companies.</p>
          </div>
          
          

          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-muted-foreground text-lg max-w-2xl mx-auto">
              <div className=""></div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-8">
            {teamMembers.map((member, i) => {
            const memberSocials = socialLinks.find(s => s.personId === member.id);
            return <Card key={member.id} data-index={i} className="bg-card text-card-foreground flex flex-col gap-6 rounded-xl py-6 w-[480px] glass-effect transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] opacity-100 translate-y-0" style={{
              transitionDelay: isVisible ? `${i * 150}ms` : "0ms"
            }}>
                  <CardContent className="flex flex-col items-center text-center p-6">
                    <div className="mb-6 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1.5">
                      <SafeHydrate><Avatar className="size-[188px] ring-2 ring-primary/20">
                        <AvatarImage src={member.photo} alt={member.name} className="aspect-square size-full object-cover object-center ![padding:-20px_0px_-20px_0px] !h-[203px]" />
                        <AvatarFallback className="bg-primary text-foreground-primary text-2xl font-display">
                          {member.name.split(" ").map(n => n[0]).join("")}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                    </div>

                    <h3 className="font-display font-semibold text-foreground-primary mb-1 !text-2xl">
                      {member.name}
                    </h3>
                    <p className="text-accent font-medium mb-3 !text-lg">
                      {member.role}
                    </p>
                    <div className="flex-1 flex items-start min-h-[120px] mb-6">
                      <p className="text-muted-foreground leading-relaxed !text-xl">
                        {member.bio}
                      </p>
                    </div>

                    {memberSocials && memberSocials.linkedin && <div className="flex gap-4 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.02]" style={{
                  marginTop: i === 0 ? "50px" : i === 1 ? "60px" : undefined
                }}>
                        <Link to={memberSocials.linkedin} newTab className="text-muted-foreground hover:text-foreground-primary transition-colors duration-[var(--duration-fast)]" aria-label={`${member.name} LinkedIn`}>
                          <Linkedin className="size-5" />
                        </Link>
                      </div>}
                  </CardContent>
                </Card>;
          })}
          </div>

          <div className="flex justify-center mt-12">
            <Link to="https://www.dropbox.com/s/377yndy1bb66z02/New%20Mavericks%20Fact%20Sheet.pdf?dl=1" newTab>
              <Button className="font-medium text-sm inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-primary-foreground shadow-xs h-9 px-4 py-2 has-[>svg]:px-3 btn-primary !py-5 !px-10 !h-auto !text-2xl !font-bold !bg-[hsl(172,66%,50%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90">Download New Mavericks Fact Sheet</Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}